import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Paper, Typography } from '@mui/material';

import { ReactComponent as EmptyWorkspaceIcon } from 'assets/icons/EmptyWorkspaceFileIcon.svg';

import { Responsive } from 'components/_basic/Responsive';
import { useHeaderLogic } from 'components/Header/HeaderLogicProvider';

import { BusinessPlanButtonList } from '../BusinessPlanButtonList/BusinessPlanButtonList';
import { CreateProjectMobile } from '../CreateProjectMobile/CreateProjectMobile';

import styles from './EmptyWorkspace.module.scss';

export const EmptyWorkspace: FC = () => {
  const { t, i18n } = useTranslation();
  const { isPayedSubscription } = useHeaderLogic();

  const getEmptyWorkspaceContent = useMemo(
    () => (
      <>
        <EmptyWorkspaceIcon />
        <Typography marginTop={'24px'} variant="body1">
          {t('startCreatingBusinessPlan')}
        </Typography>
      </>
    ),
    [i18n.language],
  );

  return (
    <>
      <Responsive aboveMobile>
        <Paper elevation={0} className={styles.emptyWorkspaceStyles}>
          {getEmptyWorkspaceContent}
          <Box className={styles.buttonContainer}>
            <BusinessPlanButtonList />
          </Box>
        </Paper>
      </Responsive>
      <Responsive mobile>
        <Box className={styles.emptyWorkspaceStylesMobile}>
          {getEmptyWorkspaceContent}
          <Box className={styles.createProjectButtonWrapper}>
            <CreateProjectMobile />
          </Box>
        </Box>
      </Responsive>
    </>
  );
};
